import { onlineManager } from '@tanstack/react-query'
import React from 'react'

import ExistingUserEmailRegistrationErrorMessage from '@/components/misc/ErrorMessage/components/ExistingUserEmailRegistrationErrorMessage'
import InvalidUserContextErrorMessage from '@/components/misc/ErrorMessage/components/InvalidUserContextErrorMessage'
import NewUpdateAvailableMessage from '@/components/misc/ErrorMessage/components/NewUpdateAvailableMessage'
import OfflineMessage from '@/components/misc/ErrorMessage/components/OfflineMessage'
import PublicEmailAliasRegistrationErrorMessage from '@/components/misc/ErrorMessage/components/PublicEmailAliasRegistrationErrorMessage'
import RequestAbortedErrorMessage from '@/components/misc/ErrorMessage/components/RequestAbortedErrorMessage'
import UnhandledErrorMessage from '@/components/misc/ErrorMessage/components/UnhandledErrorMessage'
import errorTypeService from '@/lib/services/errorTypeService'

interface Props {
  error?: unknown
}

const ErrorMessage: React.FC<Props> = ({ error }) => {
  const isOffline = !onlineManager.isOnline()

  if (isOffline) {
    return <OfflineMessage />
  }

  if (errorTypeService.isOutdatedAssetsError(error)) {
    return <NewUpdateAvailableMessage />
  }

  if (errorTypeService.isExpiredUserContextError(error)) {
    return <InvalidUserContextErrorMessage />
  }

  if (errorTypeService.isPublicEmailAliasRegistrationError(error)) {
    return <PublicEmailAliasRegistrationErrorMessage error={error} />
  }

  if (errorTypeService.isExistingUserEmailRegistrationError(error)) {
    return <ExistingUserEmailRegistrationErrorMessage error={error} />
  }

  if (errorTypeService.isAbortedRequestError(error)) {
    return <RequestAbortedErrorMessage error={error} />
  }

  return <UnhandledErrorMessage error={error} />
}

export default ErrorMessage
